import {
  normalizar,
  type NivelGovbr,
  type ServicosCategoria,
} from 'volto-ministerio-publico-federal/helpers/Servicos';

export interface ServicosCatalogoData {
  titulo?: string;
  pasta?: Array<{ '@id'?: string }>;
  exibirLegenda?: boolean;
  legenda?: string;
}

export const CATALOGO_PADRAO = {
  titulo: 'Todos os serviços',
  legenda:
    'Serviços com selo gov.br pedem login com a conta gov.br no nível indicado. Alguns serviços abrem em páginas externas; se houver instabilidade, tente novamente mais tarde.',
} as const;

const ORDEM_DOS_NIVEIS: NivelGovbr[] = ['bronze', 'prata', 'ouro'];

export function niveisPresentes(categorias: ServicosCategoria[]): NivelGovbr[] {
  const presentes = new Set(
    categorias.flatMap((c) => c.servicos.map((s) => s.govbr).filter(Boolean)),
  );
  return ORDEM_DOS_NIVEIS.filter((nivel) => presentes.has(nivel));
}

export { categoriaVisivel } from 'volto-ministerio-publico-federal/helpers/Servicos';

const semBarraFinal = (url: string) => url.replace(/\/+$/, '');

export function linkExtraVisivel(categoria: ServicosCategoria): boolean {
  if (!categoria.link_extra) return false;
  const rotulo = normalizar(categoria.link_extra_rotulo || categoria.titulo);
  const destino = semBarraFinal(categoria.link_extra);
  return !categoria.servicos.some(
    (servico) =>
      normalizar(servico.titulo) === rotulo ||
      semBarraFinal(servico.url).endsWith(destino),
  );
}
